export default __webpack_public_path__ + "static/media/goldfish.cf1adddb.mp3";